module.exports = __webpack_public_path__ + "img/kele2.97b7cf99.jpg";